import "./Login.css";
import "../index.css";
import AuskunftBoKat from "./AuskunftBoKat";
import Anmelden from "./Anmelden";
import NeuesPasswort from "./NeuesPasswort";
import BisCard from "../components/bisCard/BisCard";
import {useState} from "react";
import bdjImage from "../assets/Poster BdJ 2026_barrierefrei.png";

function Login() {

    const [showPasswordReset, setShowPasswordReset] = useState(false);
    const [resetUsername, setResetUser] = useState("");
    const [resetOldPassword, setResetOldPassword] = useState("");

    const handlePasswordReset = (username, oldPassword) => {
        setResetUser(username);
        setResetOldPassword(oldPassword);
        setShowPasswordReset(true);
    };

    const handleBackToLogin = () => {
        setShowPasswordReset(false);
        setResetUser("");
        setResetOldPassword("");
    };

    return (
        <div className="login-container">
            <div className="login-grid">
                <div className="login-content">
                    {showPasswordReset ? (
                        <BisCard child={
                            <NeuesPasswort
                                username={resetUsername}
                                passwordOld={resetOldPassword}
                                onBack={handleBackToLogin}/>
                        }/>
                    ) : (
                        <>
                            <BisCard child={<Anmelden onPasswordReset={handlePasswordReset}/>}/>
                            <AuskunftBoKat/>
                        </>
                    )}
                </div>

                <div className="bdj">
                    <a
                        href="https://boden-des-jahres.de/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Zur Website Boden des Jahres (öffnet in neuem Tab)"
                    >
                        <img
                            src={bdjImage}
                            alt="Bild zum Boden des Jahres"
                            className="bdj-image"
                        />
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Login;
